import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    '&[type="number"]': {
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
        display: 'none',
      },
      appearance: 'textfield',
    },
  },
  variants: {
    size: {
      md: {
        textStyle: 'md',
      },
      lg: {
        '--input-height': 'sizes.12',
      },
    },
    variant: {
      flushed: {},
    },
  },
});
